const Parallax = () => {
  var Rellax = require('rellax');
  new Rellax('#hero__project', {
      speed: -2,
      center: false,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false
    });

  const rellaxin = document.querySelectorAll(".parallax");
  rellaxin.forEach(el => {
      const rellax = new Rellax(el, {
          relativeToWrapper: true,
          wrapper: el.parentElement,
          speed: -6,
          center: true,
          round: true,
          vertical: true,
          horizontal: false,
      });
      window.addEventListener("scroll", () => { // fix to init
          rellax.refresh();
      });
  });  
}

export { Parallax };
